<table mat-table [dataSource]="dataSource" [attr.data-testid]="testIdPrefix + '-table'">
  @for (column of columns; track column.key) {
    <ng-container [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef>{{ column.header }}</th>
      <td mat-cell *matCellDef="let element">{{ column.getValue(element) }}</td>
    </ng-container>
  }

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        *hasPermission="PermissionTypes.ModifyAdminUsers"
        [attr.data-testid]="'remove-' + testIdPrefix + '-button'"
        mat-icon-button
        [matTooltip]="removeTooltip"
        [attr.aria-label]="removeAriaLabel"
        (click)="onRemoveClick(element)">
        <mat-icon class="red-text">delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr [attr.data-testid]="testIdPrefix + '-row'" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
